module.exports = __webpack_public_path__ + "static/media/unbound1.a74cea5a.png";